export default __webpack_public_path__ + "media/images/loop1-a3bb0d2311804c2d135ac8162e9d9475.png";